import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('Root element #root não encontrado em index.html.');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
